(function () {
  const recognized=['pantry','bakery','meals'];
  function checkArea(groups, country, postal) {
    const types=[...new Set(groups)];
    if(!types.length||types.some(g=>!recognized.includes(g)))return 'unknown_group';
    if(country!=='IN'||!/^[1-9][0-9]{5}$/.test(postal))return 'invalid';
    const local=types.some(g=>g==='bakery'||g==='meals');
    const pin=Number(postal),inside=(pin>=400001&&pin<=400104)||[400601,400602,400604,400607,400610].includes(pin);
    if(local&&!inside)return 'outside';
    if(types.length>1)return 'local_mixed';
    return local?'local':'pantry';
  }
  function incompatibleGroups(groups,result) {
    return [...new Set(groups)].filter(g=>result==='outside'?(g==='bakery'||g==='meals'):result==='unknown_group'&&!recognized.includes(g));
  }
  if(typeof module!=='undefined')module.exports={checkArea,incompatibleGroups};
  if(typeof document==='undefined')return;
  document.querySelectorAll('[data-nb-area-check]').forEach(widget=>{
    const input=widget.querySelector('input'),output=widget.querySelector('[data-nb-area-status]');
    const messages=JSON.parse(widget.querySelector('script[type="application/json"]').textContent);
    const groups=widget.dataset.groups.split(',').filter(Boolean),form=widget.closest('#nb-cart');
    const panel=form?.querySelector('[data-cart-delivery-alert]');
    const rows=panel?[...panel.querySelectorAll('[data-cart-incompatible]')]:[];
    const needsCheck=groups.some(g=>g!=='pantry');
    let checkedPostal='';
    function renderResult(result){
      output.textContent=messages[result]||messages.unknown_group;
      widget.dataset.areaResult=result;
      if(!panel)return;
      const blocked=incompatibleGroups(groups,result);
      rows.forEach(row=>row.hidden=!blocked.includes(row.dataset.deliveryGroup));
      panel.hidden=!rows.some(row=>!row.hidden);
      panel.querySelector('[data-cart-delivery-message]').textContent=result==='outside'?messages.cart_outside:messages.cart_unknown;
    }
    function check(){
      checkedPostal=input.value.trim();
      const result=checkArea(groups,'IN',checkedPostal);
      renderResult(result);
      return result;
    }
    widget.querySelector('button').addEventListener('click',check);
    input.addEventListener('keydown',event=>{
      if(event.key==='Enter'&&!event.isComposing){
        event.preventDefault();
        widget.querySelector('button').click();
      }
    });
    input.addEventListener('input',()=>{
      checkedPostal='';output.textContent='';delete widget.dataset.areaResult;
      if(panel)panel.hidden=true;
    });
    if(groups.some(g=>!recognized.includes(g)))renderResult('unknown_group');
    form?.addEventListener('submit',event=>{
      if(event.submitter?.name!=='checkout'||!needsCheck)return;
      const result=check();
      if(['outside','invalid','unknown_group'].includes(result)||checkedPostal!==input.value.trim()){
        event.preventDefault();
        if(result==='invalid'&&!input.value.trim())output.textContent=messages.cart_prompt;
        widget.scrollIntoView({block:'center',behavior:'smooth'});
        input.focus({preventScroll:true});
      }
    });
  });
})();
